module.exports = __webpack_public_path__ + "img/logo.9a78e23e.png";